package app.nestbridge.feature.invitations.screen

import com.karawek.core.circuit.Parcelize
import app.nestbridge.feature.invitations.model.Invitation
import app.nestbridge.feature.invitations.model.InvitationStatus
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class InvitationDetailScreen(
    val invitationId: String,
) : Screen

data class InvitationDetailState(
    val invitation: Invitation,
    val requiresVerification: Boolean,
    val eventSink: (InvitationDetailEvent) -> Unit,
) : CircuitUiState

sealed interface InvitationDetailEvent {
    data object OnAppear : InvitationDetailEvent
    data object Accept : InvitationDetailEvent
    data object Decline : InvitationDetailEvent
    data object DecideLater : InvitationDetailEvent
}

enum class InvitationScreenStatus {
    INITIAL,
    ACCEPTED,
    DECLINED,
    OTP_VERIFIED,
    PROFESSIONAL_PROFILE_CREATED,
    CARE_TEAM_CREATED,
}
